import { API } from "../../config";

const readResponse = async (response) => {
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(typeof data.detail === "string" ? data.detail : "Investor access could not be verified");
  return data;
};

export const checkInvestorSession = () => fetch(`${API}/invest/session`, { credentials: "include", cache: "no-store" }).then(readResponse);
export const fetchInvestorData = () => fetch(`${API}/invest/data`, { credentials: "include", cache: "no-store" }).then(readResponse);
export const loginInvestor = (code) => fetch(`${API}/invest/login`, { method: "POST", credentials: "include", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ code }) }).then(readResponse);
export const logoutInvestor = () => fetch(`${API}/invest/logout`, { method: "POST", credentials: "include" }).then(readResponse);